import { Component, OnInit, ViewChild } from "@angular/core";
import { Utils } from "src/app/shared/utils/utils";
import { Subscription } from "rxjs";
import { BankerService } from "../shared/services/banker.service";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { DatatablesUtils } from "src/app/shared/datatable-utils";

declare let swal: any;

@Component({
  selector: "app-list-banker",
  templateUrl: "./list-banker.component.html",
  styleUrls: ["./list-banker.component.css"],
})
export class ListBankerComponent implements OnInit {
  bankers: any[] = [];
  busy: Subscription;
  dtOptions: any = {};
  perPage: number = 9;
  page: number = 1;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  tri: string;
  order: string;
  ready: boolean = false;

  constructor(private bankerService: BankerService, private router: Router) {}

  ngOnInit() {
    const that = this;
    this.dtOptions = {
      dom: "['<l>', Bfrtip']",
      buttons: ["colvis"],
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      aLengthMenu: [
        [5, 10, 25, 50, 100000],
        [5, 10, 25, 50, "All"],
      ],
      ajax: (dataTablesParameters: any, callback) => {
        const page = (dataTablesParameters.start / dataTablesParameters.length + 1);
        const perPage = dataTablesParameters.length;
        const search = dataTablesParameters.search.value;


        that.busy = that.bankerService
          .getPaginatedBankers(perPage, page, search)
          .subscribe(
            (data: any) => {
              this.bankers = data;
              console.log(this.bankers)

              callback({
                recordsTotal: data.length,
                recordsFiltered: data.length,
                data: that.bankers,
              });
            },
            (error) => {
              Utils.sweetAlert('error', 'Erreur', 'Erreur lors du chargement des banquiers');
            }
          );
      },
      columns: this.getColumns(),
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        jQuery(".action-btn", row).unbind("click");
        jQuery(".action-btn", row).bind("click", (event) => {
          const actionId = parseInt($(event.target).attr("action-id"), 0);
          this.goToAction(actionId, data);
        });
      },
    };
  }

  getColumns() {
    return [
      { data: "id", visible: true },
      {
        data: "name",
        visible: true,
        render: function (data, type, row) {
          return row.name;
        },
      },
      { data: "email", visible: true },
      {
        data: "phone",
        visible: true,
        render: function (data, type, row) {
          return row.phone ? row.phone : "-";
        },
      },
      {
        data: "Banque",
        visible: true,
        render: function (data, type, row) {
          return row.bank_name ? row.bank_name : "-";
        },
      },
      {
        data: "actions",
        visible: true,
        render: function () {
          return DatatablesUtils.renderActionsBtn();
        },
      },
    ];
  }

  private goToAction(actionId: number, data) {
    switch (actionId) {
      case 1:
        // Edit banker
        this.router.navigate(["/bankers", data.id, "edit"]);
        break;
      case 2:
        // Delete banker
        this.removeBanker(data.id);
        break;
    }
  }

  removeBanker(id: number) {
    swal({
      title: "Êtes-vous sûr ?",
      text: "Cette action est irréversible !",
      icon: "warning",
      buttons: ["Annuler", "Supprimer"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.busy = this.bankerService.deleteBanker(id).subscribe(
          () => {
            Utils.sweetAlert("success", "Succès", "Banquier supprimé avec succès");
            // Rafraîchir la table
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.ajax.reload(null, false);
            });
          },
          () => {
            Utils.sweetAlert("error", "Erreur", "Erreur lors de la suppression");
          }
        );
      }
    });
  }
}
